import { render, staticRenderFns } from "./move-vehicle.vue?vue&type=template&id=33f5cfe2&"
import script from "./move-vehicle.vue?vue&type=script&lang=js&"
export * from "./move-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports